import { useMemo } from "react";
import { buildParticipantIds } from "@/features/chat/utils/participants";
import { useExistingDmAndTopicChats } from "@/hooks/useExistingDmAndTopicChats";
import type { UserShort } from "@/lib/humhub-api/types";

interface UseParticipantsSearchStateParams {
  isOpen: boolean;
  searchMode: "keyword" | "participants";
  selectedParticipants: UserShort[];
  currentUserId?: number;
}

export const useParticipantsSearchState = ({
  isOpen,
  searchMode,
  selectedParticipants,
  currentUserId,
}: UseParticipantsSearchStateParams) => {
  const isParticipantsMode = searchMode === "participants";
  const hasParticipants = selectedParticipants.length > 0;

  const participantIds = useMemo(() => {
    if (!isParticipantsMode) {
      return [];
    }
    return buildParticipantIds(selectedParticipants, currentUserId, true);
  }, [currentUserId, isParticipantsMode, selectedParticipants]);

  const {
    existingDmChats,
    existingTopicChats,
    isCheckingExisting,
    dmError,
    topicError,
  } = useExistingDmAndTopicChats(
    participantIds,
    isOpen && isParticipantsMode && participantIds.length > 0,
  );

  return {
    hasParticipants,
    participantIds,
    existingDmChats,
    existingTopicChats,
    isCheckingExisting,
    error: dmError || topicError,
  };
};
